module.exports = __webpack_public_path__ + "img/case_bottom_002.7219d4b2.png";